;(function () {
  const hamburger = document.getElementById('hamburger')

  const sidebar = document.querySelector('.sidebar')

  const closeBtn = document.getElementById('close')

  const mask = document.createElement('div')
  mask.className = 'mask'
  mask.style.backgroundColor = 'rgba(0, 0, 0, 0.5)'
  mask.style.position = 'fixed'
  mask.style.top = '0'
  mask.style.left = '0'
  mask.style.width = '100%'
  mask.style.height = '100%'
  mask.style.zIndex = '50'

  if (hamburger && sidebar)
    hamburger.addEventListener('click', function () {
      sidebar.classList.toggle('sidebar--active')
      document.body.appendChild(mask)
    })

  if (closeBtn && sidebar)
    closeBtn.addEventListener('click', function () {
      sidebar.classList.remove('sidebar--active')
      document.body.removeChild(mask)
    })

  /**
   * sidebar item click event
   */
  const sidebarItems = document.querySelectorAll('.sidebar__body__item__title')

  const activeItem = document.querySelectorAll('.sidebar__body__item')

  for (let i = 0; i < sidebarItems.length; i++) {
    const el = activeItem[i]
    sidebarItems[i].addEventListener('click', function () {
      if (!el || !el.classList.contains('sidebar__body__item')) return

      if (el.classList.contains('sidebar__body__item--active')) {
        el.classList.remove('sidebar__body__item--active')
        return
      } else {
        el.classList.add('sidebar__body__item--active')
      }
    })
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth > 768) {
      if (sidebar) sidebar.classList.remove('sidebar--active')
      document.body.removeChild(mask)
    }
  })
})()
